"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdobeTracking = void 0;
var root = require("window-or-global");
var AdobeTracking = (function () {
    function AdobeTracking(mutationToHandler, onlyLogToConsole) {
        if (onlyLogToConsole === void 0) { onlyLogToConsole = false; }
        this.mutationToHandler = mutationToHandler;
        this.onlyLogToConsole = onlyLogToConsole;
    }
    AdobeTracking.prototype.sender = function (event) {
        ;
        root.adobeDataLayer.push(event);
    };
    AdobeTracking.prototype.onStateChange = function (mutation, state) {
        var f = this.mutationToHandler[mutation.type];
        if (f) {
            for (var _i = 0, _a = f(mutation, state, undefined, undefined); _i < _a.length; _i++) {
                var event_1 = _a[_i];
                if (this.onlyLogToConsole) {
                    console.log(event_1);
                }
                else {
                    this.sender(event_1);
                }
            }
        }
    };
    return AdobeTracking;
}());
exports.AdobeTracking = AdobeTracking;
//# sourceMappingURL=index.js.map